import PropTypes from 'prop-types'
import { Button } from '@chakra-ui/react'

export const RoundButton = ({
  children,
  bgColor = 'black',
  color = 'white',
  variant = 'solid',
  p = '0px',
  width = '100%',
  height = '44px',
  fontSize,
  ...props
}) => {
  const styles = {
    solid: {
      bg: bgColor,
      color: color,
      _hover: {
        opacity: 0.6,
      },
    },
    outline: {
      bg: 'white',
      borderColor: bgColor,
      borderWidth: 1,
      color: color,
      _hover: {
        opacity: 0.6,
      },
    },
  }

  return (
    <Button borderRadius="9999px" p={p} width={width} height={height} fontSize={fontSize} {...styles[variant]} {...props}>
      {children}
    </Button>
  )
}

RoundButton.propTypes = {
  children: PropTypes.node.isRequired,
  p: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fontSize: PropTypes.string,
  variant: PropTypes.string,
  bgColor: PropTypes.string,
  color: PropTypes.string,
}
